import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { ROLES } from "../../utils/roles";

export interface NavItem {
    label: string;
    path?: string;
    children?: { label: string; path: string }[];
}

export function useNavItems(): NavItem[] {
    const { userRole, authReady } = useSelector((state: RootState) => state.auth);
    const isAdmin = authReady && userRole === ROLES.A12_B;

    return [
        { label: "Inicio", path: "/" },
        ...(isAdmin ? [{
            label: "Personal",
            children: [
                { label: "Ideas", path: "/ideas" },
                { label: "Viajes", path: "/viajes" },
                { label: "Ranking", path: "/ranking" },
                { label: "Recetas", path: "/recetas" },
                { label: "Galería de Fotos", path: "/galeria" },
                { label: "Diario Trading", path: "/diario-trading" },
                { label: "Nuestro Tiempo", path: "/nuestro-tiempo" },
                { label: "Control de Pesos", path: "/control-pesos" }
            ]
        }] : []),
        {
            label: "Utilidades",
            children: [
                { label: "Ruleta de Ganadores", path: "/ganador-aleatorio" },
                { label: "Generar equipos", path: "/generar-equipos" },
                { label: "Calculadora Forex", path: "/calculadora-forex" },
                { label: "Calculadora Raciones", path: "/calculadora-raciones" },
                { label: "Calc. Consistencia", path: "/calculadora-lucid" }
            ]
        },
        ...(isAdmin ? [{
            label: "Juegos",
            children: [
                { label: "Sopa de Letras", path: "/sopa-de-letras" }
            ]
        }] : []),
        { label: "Correos", path: "/correos" },
        { label: "Acerca", path: "/acerca" },
        { label: "Contacto", path: "/contacto" }
    ];
}
